module.exports = "/_next/static/images/1349314f7810b54778094b372d9f563d-man-holding-two-phones@1x.jpg.webp";